/* import __COLOCATED_TEMPLATE__ from './content.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class Content extends Component {
  @service intercomEventService;
  @service notificationsService;
  @service appService;
  @service intl;

  @tracked showVerificationError = false;
  @tracked isVerifying = false;
  @tracked openSectionId;

  get app() {
    return this.appService.app;
  }

  get hasAllDnsRecordsAuthenticated() {
    return (
      this.args.domainSettings.dkimRecord?.validRecordExists &&
      this.args.domainSettings.customBounceSetting?.validRecordExists &&
      this.args.domainSettings.dkimRecord?.validDmarcExists
    );
  }

  get hasVerifiedEmails() {
    return (
      this.args.domainSettings.dkimRecord.hasVerifiedAdminEmails ||
      (this.customSenderAddresses &&
        this.customSenderAddresses.filter((address) => address.verified).length > 0)
    );
  }

  get customSenderAddresses() {
    return this.args.domainSettings.customAddresses;
  }

  @action onOpenSectionChange(newOpenSectionId) {
    this.openSectionId = newOpenSectionId;
  }

  @action trackOpenSection(sectionName) {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'opened',
      object: `accordion-section_${sectionName}`,
      place: 'settings_email_domains',
    });
  }

  @action trackCloseSection(sectionName) {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'closed',
      object: `accordion-section_${sectionName}`,
      place: 'settings_email_domains',
    });
  }

  @action
  async verifyDomain(domainSettings) {
    try {
      this.isVerifying = true;
      let dkimSettingsModel = domainSettings.dkimRecord;
      await dkimSettingsModel.verify();
      this.notificationsService.notifyConfirmation(
        this.intl.t('settings.domains.manage.domain-verification-success'),
      );
      this.intercomEventService.trackAnalyticsEvent({
        action: 'success',
        object: `verify_domain`,
        place: 'settings_email_domains',
      });
    } catch (error) {
      this.showVerificationError = true;
      this.intercomEventService.trackAnalyticsEvent({
        action: 'error',
        object: `verify_domain`,
        place: 'settings_email_domains',
      });
    } finally {
      this.isVerifying = false;
    }
  }
}
